import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { TmAccountDetails } from "../TmAccountDetails";
import { Box } from "@mui/material";
import { useGroupInviteFlow } from "src/components/feature/groupInviteFlow/useGroupInviteFlow";
import React from "react";

export const useCreateGroupConfirmModal = createState({
  isOpen: false,
  errorMessage: "",
});

export function CreateGroupConfirmModal() {
  const router = useRouterExt();
  const modalState = useCreateGroupConfirmModal();
  const { handleCreateGroup } = useGroupInviteFlow();
  const [isConfirming, setIsConfirming] = React.useState(false);

  const onClose = () => {
    modalState.reset();
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Create a Group"
      description={
        <Box py={1}>
          By creating a group you’re accepting the role and responsibilities of
          Group Leader. You’ll be able to add friends and remove them at any
          time.
        </Box>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Create Group",
          isLoading: isConfirming,
          isDisabled: isConfirming,
          onClick: async () => {
            setIsConfirming(true);
            await handleCreateGroup();
            setIsConfirming(false);
            onClose();
          },
        },
        secondaryButton: {
          label: "Cancel",
          onClick: () => onClose(),
        },
      }}
    />
  );
}
